import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import OCRScopeNewJobButton from '../../OCRScopeNewJobButton'
import CreateOCRScopeJobsViewModel from '../../../views/CreateOCRScopeJobsDialog/CreateOCRScopeJobsViewModel'
import OCRScopingJobBulkActionViewModel from '../OCRScopingJobBulkActionViewModel'

interface OCRBulkActionButtonProps {
  vm: OCRScopingJobBulkActionViewModel
  createOCRScopeJobsViewModel: CreateOCRScopeJobsViewModel
}

export default observer(function OCRBulkActionButton({
  vm,
  createOCRScopeJobsViewModel,
}: OCRBulkActionButtonProps) {
  if (
    vm.selectedStatusFilter === undefined ||
    vm.selectedStatusFilter.bulkAction === undefined
  ) {
    return (
      <OCRScopeNewJobButton vm={createOCRScopeJobsViewModel} wideSlimButton />
    )
  }

  const bulkAction = vm.selectedStatusFilter.bulkAction
  return (
    <Button
      size="wide-slim"
      type="primary"
      disabled={
        !vm.hasAnyItemsSelectedForBulkAction ||
        bulkAction.bulkActionHandler.pending
      }
      onClick={bulkAction.bulkActionModal?.show || bulkAction.bulkActionHandler}
    >
      {bulkAction.bulkActionName}
    </Button>
  )
})
